/*
*###############################################################################
*Module Name                   : DPSearchBox.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal, TabContent, TabPane } from "reactstrap"
import DPNavBar from "framework/widgets/DPNavBar";
import DPDropDown from "./DPDropDown";

const DPProductExcelUploadPopUp = (props) => {

    const [tabList, setTabList] = useState([{
        text: "Success List",
        icon: "fas fa-home",
        tabID: "1",
        onClick: () => {
            toggleCustom("1");
        },
    }, {
        text: "Failed List",
        icon: "fas fa-home",
        tabID: "2",
        onClick: () => {
            toggleCustom("2");
        },
    }]);
    const [activeTab, setActiveTab] = useState("1");

    const toggleCustom = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab)
        } else {
            setActiveTab("1")
        }
    }

    return (
        <div>
            <Modal
                size="xl"
                isOpen={props.isOpen}
                toggle={props.toggle}
                backdrop="static"
                centered  
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">

                    <DPNavBar buttons={tabList} activeStatus={activeTab} />
                    <TabContent activeTab={activeTab} className="p-3 text">
                        <TabPane tabId="1">
                            <DisplayTable dataSet={props.excelSuccessResult} activeTab={activeTab} />
                        </TabPane>
                        <TabPane tabId="2">
                            <DisplayTable dataSet={props.excelFailedResult} activeTab={activeTab} />
                        </TabPane>
                    </TabContent>

                </div>
            </Modal>
        </div>
    );
}

export default DPProductExcelUploadPopUp;



const DisplayTable = ({ dataSet, activeTab }) => {

    const [postsPerPage, setPostsPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = dataSet.slice(indexOfFirstPost, indexOfLastPost)

    useEffect(() => {
        setCurrentPage(1)
    }, [activeTab])

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };
    return (<div>

        <Row>
            <table className="table table-bordered table-centered table-hover table-sm">
                <thead className="table-light">
                    <tr>
                        <th>Code</th>
                        <th>Reason</th>
                    </tr>
                </thead>
                <tbody>
                    {currentPosts.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{item.ProductCode}</td>
                                <td>{item.Reason}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </Row>

        <Row>
            <Col md="2">
                <DPDropDown
                    label="Rows Per Page"
                    optionGroup={[{
                        "value": 10,
                        "label": "10"
                    }, {
                        "value": 20,
                        "label": "20"
                    }, {
                        "value": 50,
                        "label": "50"
                    }, {
                        "value": 100,
                        "label": "100"
                    }
                    ]}
                    onChange={(e) => setPostsPerPage(e["value"])}
                    selectedGroup={postsPerPage}
                />
            </Col>
            <Col md="10">
                <ReactPaginate
                    previousLabel={'Previous'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={Math.ceil(dataSet.length / postsPerPage)}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    forcePage={currentPage - 1}
                    renderOnZeroPageCount={null}
                    activeClassName={'active'}
                    activeLinkClassName={'page-link'}
                    containerClassName={'pagination justify-content-center pagination-sm'}
                />
            </Col>
        </Row>
    </div>
    )

}